import { render } from "./esim_orders.vue?vue&type=template&id=f6b61098"
import script from "./esim_orders.vue?vue&type=script&lang=js"
export * from "./esim_orders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__